module.exports = __webpack_public_path__ + "static/media/dcc1212-60a.9629d71b.jpg";